let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("bUPwj")]).then(() => parcelRequire('4z8RD'));